var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { CONTEXT_PROPS } from '../../../renderer';
import { getValueByIdentifier } from '../values/get-by-identifier';
import { EXTERNAL_IDENTIFIERS } from '../../types/Identifiers';
export function getContext(siteLevelSeoData, pageLevelSeoData, userPatternSchema) {
    var _a;
    return __assign(__assign({}, siteLevelSeoData.context), (_a = {}, _a[CONTEXT_PROPS.PAGE_NAME] = pageLevelSeoData.pageName, _a[CONTEXT_PROPS.TITLE] = pageLevelSeoData.title, _a[CONTEXT_PROPS.DESCRIPTION] = pageLevelSeoData.description, _a[CONTEXT_PROPS.OG_IMAGE] = pageLevelSeoData.ogImage, _a[CONTEXT_PROPS.OG_IMAGE_WIDTH] = pageLevelSeoData.ogImageWidth, _a[CONTEXT_PROPS.OG_IMAGE_HEIGHT] = pageLevelSeoData.ogImageHeight, _a[CONTEXT_PROPS.INDEX_PAGE] = pageLevelSeoData.indexPage, _a[CONTEXT_PROPS.ROBOTS_FROM_USER_PATTERN] = getValueByIdentifier(userPatternSchema.tags, EXTERNAL_IDENTIFIERS.ROBOTS), _a));
}
